(() => {
  'use strict';
  if (window.rljBookingInitialized) return;
  window.rljBookingInitialized = true;
  const base = 'https://calendly.com/raymondleejewelers-info/';
  const dialog = document.getElementById('rlj-booking-dialog');
  const routes = {
    'collateral-loans': 'new-meeting',
    'jewelry-repair': 'jewelry-or-watch-repair-consultation',
    'watch-repair': 'jewelry-or-watch-repair-consultation',
    'custom-jewelry-design': 'custom-jewelry-design-consultation',
    'appraisals': 'jewelry-appraisal-appointment',
    'financing-option': 'fine-jewelry-shopping-appointment',
    'sell-to-us-general': 'instant-sell-quote',
    'sell-gold': 'instant-sell-quote',
    'sell-jewelry-boca-raton': 'sell-your-jewelry-or-diamonds',
    'sell-diamond-boca-raton': 'sell-your-jewelry-or-diamonds',
    'sell-watches-boca-raton': 'sell-your-watch',
    'sell-watches': 'sell-your-watch',
    'sell-my-rolex': 'sell-your-watch',
    'consignment': 'new-meeting-1',
    'trade-in': 'trade-in-shopping-appointment',
    'insurance-replacement': 'insurance-replacement-consultation',
    'fine-jewelry': 'fine-jewelry-shopping-appointment',
    'bridal': 'engagement-bridal-consultation'
  };
  const allowed = new Set([
    'new-meeting', 'new-meeting-1', 'instant-sell-quote', 'sell-your-watch',
    'sell-your-jewelry-or-diamonds', 'engagement-bridal-consultation',
    'fine-jewelry-shopping-appointment', 'jewelry-or-watch-repair-consultation',
    'custom-jewelry-design-consultation', 'jewelry-appraisal-appointment',
    'insurance-replacement-consultation', 'sell-luxury-handbags',
    'trade-in-shopping-appointment'
  ]);
  const legacy = { '/d/cx6z-zt8-jnj/collateral-loan-consultation': 'new-meeting' };
  const title = document.getElementById('rlj-booking-title');
  const choices = dialog?.querySelector('[data-rlj-booking-choices]');
  const calendar = dialog?.querySelector('[data-rlj-booking-calendar]');
  const embed = dialog?.querySelector('[data-rlj-booking-embed]');
  const external = dialog?.querySelector('[data-rlj-booking-external]');
  const heading = dialog?.querySelector('[data-rlj-calendar-heading]');
  const back = dialog?.querySelector('[data-rlj-booking-back]');
  let opener = null;
  let activeSlug = '';
  let previousOverflow = '';
  let widgetPromise;
  let calendarVersion = 0;
  const completed = new Set();
  const parsed = link => {
    try { return new URL(link.href, location.href); } catch (_) { return null; }
  };
  const owned = url => url && url.protocol === 'https:' && url.hostname === 'calendly.com' &&
    (url.pathname === '/raymondleejewelers-info' || url.pathname.startsWith('/raymondleejewelers-info/') || legacy[url.pathname]);
  const track = (event, details = {}) => {
    const privacy = window.Shopify?.customerPrivacy;
    if (privacy?.analyticsProcessingAllowed && !privacy.analyticsProcessingAllowed()) return;
    if (window.Shopify?.designMode) return;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, page_path: location.pathname, ...details });
  };
  const pageSlug = () => {
    if (!dialog) return '';
    if (['product', 'collection'].includes(dialog.dataset.pageType)) {
      return /engagement|bridal|wedding/.test(dialog.dataset.shoppingHandle || '')
        ? 'engagement-bridal-consultation' : 'fine-jewelry-shopping-appointment';
    }
    return routes[dialog.dataset.pageHandle] || '';
  };
  const position = link => link?.dataset.sellerPosition ||
    (link?.closest('.site__header,.header__drawer') ? 'navigation' : 'content');
  const resolve = link => {
    const url = parsed(link);
    if (!owned(url)) return null;
    const selector = link.hasAttribute('data-rlj-booking-picker') ||
      (link.closest('.site__header,.header__drawer') && /\/(instant-sell-quote)?$/.test(url.pathname));
    if (selector) return { url, slug: '', selector: true };
    let slug = legacy[url.pathname] || url.pathname.split('/').filter(Boolean)[1] || '';
    if (!link.closest('#rlj-booking-dialog') && slug === 'instant-sell-quote' && pageSlug()) slug = pageSlug();
    if (!allowed.has(slug)) return { url, slug: '', selector: true };
    url.pathname = '/raymondleejewelers-info/' + slug;
    return { url, slug, selector: false };
  };
  const utms = url => {
    const source = new URL(location.href);
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'].forEach(key => {
      if (!url.searchParams.has(key) && source.searchParams.has(key)) url.searchParams.set(key, source.searchParams.get(key).slice(0, 255));
    });
    return url;
  };
  const refresh = scope => {
    scope.querySelectorAll('a[href]').forEach(link => {
      if (link.closest('#rlj-booking-dialog')) return;
      const result = resolve(link);
      if (!result) return;
      if (result.selector) {
        link.href = base.slice(0, -1);
        link.setAttribute('data-rlj-booking-picker', '');
      } else link.href = result.url.href;
    });
  };
  const loadWidget = () => {
    if (window.Calendly?.initInlineWidget) return Promise.resolve();
    if (widgetPromise) return widgetPromise;
    widgetPromise = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = 'https://assets.calendly.com/assets/external/widget.js';
      script.async = true;
      script.onload = () => window.Calendly?.initInlineWidget ? resolve() : reject();
      script.onerror = reject;
      document.head.appendChild(script);
    });
    return widgetPromise;
  };
  const showChoices = () => {
    calendarVersion++;
    activeSlug = '';
    choices.hidden = false;
    calendar.hidden = true;
    back.hidden = true;
    dialog.setAttribute('aria-labelledby', 'rlj-booking-title');
    embed.replaceChildren();
    title.focus();
  };
  const showCalendar = (result, link) => {
    activeSlug = result.slug;
    const expectedVersion = ++calendarVersion;
    choices.hidden = true;
    calendar.hidden = false;
    back.hidden = false;
    const option = dialog.querySelector('[data-rlj-appointment="' + result.slug + '"]');
    heading.textContent = option?.textContent.replace('↗', '').trim() || dialog.dataset.calendarTitle;
    heading.id = 'rlj-calendar-title';
    dialog.setAttribute('aria-labelledby', heading.id);
    dialog.querySelector('[data-rlj-loan-note]').hidden = result.slug !== 'new-meeting';
    const url = utms(result.url);
    external.href = url.href;
    embed.replaceChildren();
    embed.style.minHeight = '';
    embed.style.height = '';
    heading.focus();
    track('seller_booking_click', {
      seller_category: link.closest('[data-seller-category]')?.dataset.sellerCategory || result.slug,
      cta_position: position(opener || link), booking_event: url.pathname
    });
    loadWidget().then(() => {
      if (!dialog.open || calendarVersion !== expectedVersion) return;
      window.Calendly.initInlineWidget({ url: url.href, parentElement: embed });
    }).catch(() => {
      if (calendarVersion !== expectedVersion) return;
      embed.style.minHeight = '0';
      embed.style.height = '0';
    });
  };
  if (dialog && typeof dialog.showModal === 'function') {
    dialog.querySelector('[data-rlj-booking-close]').addEventListener('click', () => dialog.close());
    back.addEventListener('click', showChoices);
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    });
    dialog.addEventListener('close', () => {
      calendarVersion++;
      activeSlug = '';
      embed.replaceChildren();
      document.body.style.overflow = previousOverflow;
      if (opener?.isConnected) opener.focus();
    });
  }
  document.addEventListener('click', event => {
    const link = event.target.closest?.('a[href]');
    if (!link || link.matches('[data-rlj-booking-external]')) return;
    const result = resolve(link);
    if (!result) return;
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || !dialog || typeof dialog.showModal !== 'function') return;
    event.preventDefault();
    if (!dialog.open) {
      opener = link;
      previousOverflow = document.body.style.overflow;
      dialog.showModal();
      document.body.style.overflow = 'hidden';
    }
    if (result.selector) {
      showChoices();
      track('appointment_selector_open', { cta_position: position(link) });
    } else showCalendar(result, link);
  });
  window.addEventListener('message', event => {
    if (!dialog?.open || !activeSlug || event.origin !== 'https://calendly.com') return;
    const frame = embed.querySelector('iframe');
    if (!frame || event.source !== frame.contentWindow || event.data?.event !== 'calendly.event_scheduled') return;
    const uri = event.data.payload?.event?.uri;
    if (typeof uri !== 'string' || !/^https:\/\/api\.calendly\.com\/scheduled_events\/[a-zA-Z0-9-]+$/.test(uri)) return;
    if (completed.has(uri)) return;
    completed.add(uri);
    track('appointment_booked', { appointment_type: activeSlug, cta_position: position(opener) });
  });
  refresh(document);
  document.addEventListener('shopify:section:load', event => refresh(event.target));
})();
